import { MEDIA_DIR } from '../constants'
import { values, includes } from 'lodash/fp'

import { logManager } from '../logs'
const log = logManager.getLogger('SdpPipeline')

/**
 * Sets a transceiver's direction.
 * Checks that the desired direction is a valid one.
 * @method setTransceiverDirection
 * @param {Object} transceiver The transceiver that we want to modify.
 * @param {String} targetDirection The desired direction we want to change to.
 * @return {Boolean} Indicator on whether the transceiver direction was successfully changed.
 */
export function setTransceiverDirection (transceiver, targetDirection) {
  if (!includes(targetDirection, values(MEDIA_DIR))) {
    log.info(`Invalid direction "${targetDirection}"`)
    return false
  }

  // Only in Safari:
  //  - has transceiver.setDirection
  //  - transceiver.direction is readOnly
  if (transceiver.setDirection) {
    transceiver.setDirection(targetDirection)
  } else {
    transceiver.direction = targetDirection
  }
  return true
}
